import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

const StyledToolbar = styled('div')`
  padding: 12px 35px 12px 24px;
  background-color: ${COLOR.white};
  display: flex;
  align-items: center;
  justify-content: center;

  .toolbar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 1200px;
    width: 100%;
    padding-right: 16px;
    box-sizing: border-box;
  }

  .toolbar-loading {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 8px;
    max-width: 1200px;
    width: 100%;

    .toolbar-loading-spinner {
      color: ${COLOR.blue600};
    }
  }

  .toolbar-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;

    .refresh-button {
      width: 32px;
      height: 32px;
      padding: 4px;
      border-radius: 8px;
      border: 1px solid ${COLOR.indigo[16]};

      .refresh-icon {
        width: 20px;
        height: 20px;
        color: ${COLOR.secondary[8]};
      }
    }
  }

  .sub-cta {
    position: relative;
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    align-items: center;
  }

  .scroll-area {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    width: 100%;
    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    .refresh-button {
      width: 32px;
      height: 32px;
      padding: 4px;
      border-radius: 8px;
      border: 1px solid ${COLOR.indigo[16]};
      flex-shrink: 0;

      .refresh-icon {
        width: 20px;
        height: 20px;
        color: ${COLOR.secondary[8]};
      }
    }
  }

  .scroll-spacer {
    flex: 0 0 auto;
    margin-left: auto;
  }

  .toolbar-divider {
    flex-shrink: 0;
    width: 1px;
    height: 24px;
    background-color: ${COLOR.indigo[16]};
  }

  .scroll-edge-wrap {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 56px;
    display: flex;
    align-items: center;
    pointer-events: none;
    z-index: 2;

    &.right {
      right: -16px;
      justify-content: flex-end;
      background: linear-gradient(
        to left,
        ${COLOR.white} 40%,
        rgba(255, 255, 255, 0)
      );
    }

    &.left {
      left: 0;
      justify-content: flex-start;
      background: linear-gradient(
        to right,
        ${COLOR.white} 40%,
        rgba(255, 255, 255, 0)
      );
    }

    .scroll-edge {
      pointer-events: auto;
      width: 28px;
      height: 28px;
      padding: 2px;
      background-color: ${COLOR.white};
      border: 0.5px solid ${COLOR.indigo[16]};
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
      border-radius: 50%;

      .scroll-edge-icon {
        width: 20px;
        height: 20px;
        color: ${COLOR.indigo.default};
      }
    }
  }

  /* @media screen and (min-width: 1440px) {
    padding: 12px 80px;
  }

  @media screen and (min-width: 1920px) {
    padding: 12px 320px;
  } */
`;

const StyledItemVoice = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
`;

export { StyledToolbar, StyledItemVoice };
